import {Component, OnInit} from '@angular/core';
import {ErrorModel} from '../../../../../models/shared/error.model';
import {StudentService} from '../../../../../services/student/student.service';
import {ModalService} from '../../../../../shared/modals/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import {StudentModel} from '../../../../../models/authentication/student.model';
import {UserModel} from '../../../../../models/authentication/user.model';
import {Router} from '@angular/router';
import {ChargebeeService} from '../../../../../services/student/chargebee.service';

@Component({
  selector: 'app-new-billing-settings',
  templateUrl: './new-billing-settings.component.html',
  styleUrls: ['./new-billing-settings.component.css']
})
export class NewBillingSettingsComponent implements OnInit {

  public students: StudentModel[] = [];

  constructor(private studentSv: StudentService,
              private modalSv: ModalService,
              private router: Router,
              private cbSv: ChargebeeService,
              public tSv: TranslateService) {
  }

  ngOnInit() {

    this.studentSv.fetchStudents().subscribe((students) => {

      this.students = students.filter((s) => {

        return s._creator === UserModel.getCurrent()._id;
      });

      this.students = this.students.sort((a, b) => {

        if (a.fullName(this.tSv) > b.fullName(this.tSv)) {
          return 1;
        }

        if (a.fullName(this.tSv) < b.fullName(this.tSv)) {
          return -1;
        }

        return 0;
      });
    }, (error: ErrorModel) => {

      this.modalSv.showErrorModal(this.tSv.instant('reusable.error'),
        this.tSv.instant('reusable.unknownError'));

    });
  }

  onManageSubscriptionClicked(studentId: string) {

    if (window['Chargebee']) {
      const cbInstance = window['Chargebee'].getInstance();

      // Implementation for portal sessions: https://www.chargebee.com/checkout-portal-docs/api-portal.html#integration-steps
      cbInstance.setPortalSession(() => {
        return this.cbSv.manageSubscriptionCheckout(studentId);
      });


      const cbPortal = cbInstance.createChargebeePortal();
      cbPortal.open({
        close: () => {
          // close callbacks
          // Update the student status if the user has changed their subscription.
          this.cbSv.updateStudentSubscriptionStatus(studentId).subscribe((student) => {
            StudentModel.setCurrent(student);
          });
        }
      });
    }

  }

  cancelSubscriptionClicked(studentId: string) {

    this.studentSv.cancelSubscription(studentId).subscribe((response) => {

      // Manually fetches the updated student record and updates in our backend instead
      // of relying on webhooks.
      this.cbSv.updateStudentSubscriptionStatus().subscribe((student) => {
        console.log('get updated student subscription status: ' + JSON.stringify(student, null, 4));
        StudentModel.setCurrent(student);

        this.modalSv.showAlertModal(this.tSv.instant('reusable.success'),
          this.tSv.instant('reusable.successMessage'));

      });

    }, (err: ErrorModel) => {
      this.modalSv.showTranslatedErrorModal(err);
    });
  }

  buyNowClicked(studentId: string) {
    this.router.navigate(['selectsub'], {queryParams: { student: studentId }});
  }

  /**
   * TODO we need a state to handle renewal which is currently not supported.
   */

}
